// extracted by mini-css-extract-plugin
export default {"panel":"style_panel__Ihnvj","panel__action":"style_panel__action__VqhVd","panel__table":"style_panel__table__G-fbc","panel__header":"style_panel__header__HcFz6"};